import BlocDeContinguts from 'components/3cat/BlocDeContinguts';

const _getUrl = (url) => {
    return url?.replace('%%dataResources.apiCCMA%%', 'https://api.3cat.cat');
};

export default function BlocDeContingutsWrapper(props) {
    const {
        tipus,
        paginacio,
        items,
        url,
        className,
        itemType,
        format,
        classNameMosaic,
        routeType,
        slugRelacio,
        mostraCodiEtic,
        mostrarNomPrograma
    } = props;
    const finalUrl = _getUrl(url);
    return (
        <BlocDeContinguts
            paginacio={paginacio}
            items={items}
            tipus={tipus}
            url={finalUrl}
            className={className}
            routeType={routeType}
            slugRelacio={slugRelacio}
            format={format}
            classNameMosaic={classNameMosaic}
            itemType={itemType}
            mostraCodiEtic={mostraCodiEtic}
            mostrarNomPrograma={mostrarNomPrograma}
        />
    );
}
BlocDeContingutsWrapper.defaultProps = {
    mostraCodiEtic: true,
    slugRelacio: '',
    mostrarNomPrograma: false
};
